import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import OnboardingLandingGeneric from '../../onboarding/start/OnboardingLandingGeneric';
import HeadOpenGraphMeta from '../../global/HeadOpenGraphMeta';
import { getAsset } from '../../../util/assets';
import getConfig from '../../../util/config';
import LogoPoweredBy from '../../global/LogoPoweredBy';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    album_type: PropTypes.string,
    album_subtype: PropTypes.string,
  }),
  onGetStarted: PropTypes.func.isRequired,
};

const DiscoverAlbumFolderStartGeneric = ({ albumFolder, onGetStarted }) => {
  const config = getConfig();

  return (
    <Fragment>
      <HeadOpenGraphMeta
        title="Delivering the memories that matter most"
        imageUrl={getAsset('/og-link-preview-pro.png')}
      />
      <OnboardingLandingGeneric
        stringContext={albumFolder}
        onGetStarted={onGetStarted}
      />
      <a
        href={config.marcomUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="discovery-start-logo"
      >
        <LogoPoweredBy />
      </a>
    </Fragment>
  );
};

DiscoverAlbumFolderStartGeneric.propTypes = propTypes;

export default DiscoverAlbumFolderStartGeneric;
